import { render, staticRenderFns } from "./LocalizarTributacao.vue?vue&type=template&id=8985e15e&scoped=true"
import script from "./LocalizarTributacao.vue?vue&type=script&lang=js"
export * from "./LocalizarTributacao.vue?vue&type=script&lang=js"
import style0 from "./LocalizarTributacao.vue?vue&type=style&index=0&id=8985e15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8985e15e",
  null
  
)

export default component.exports